import styled, { css } from 'styled-components'

import { color, font, fontWeight } from 'styles/global'
import { MAX_WIDTH } from 'styles/theme'
import { space } from 'styles/utils'

export const NavigationVars = css`
  --navigation-height: 72px;
  --navigation-width: 64px;
`

export const NavigationWrapper = styled.div`
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  margin: 0 auto;
  max-width: ${MAX_WIDTH};
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 10;

  /* &:before,
  &:after {
    background: ${color('secondaryBackground')};
    bottom: 0%;
    content: '';
    display: none;
    height: 100vh;
    pointer-events: none;
    position: absolute;
    top: 0;
    transform: translate(-100%);
    width: 100%;
  } */

  /* &:after {
    right: 0;
    transform: translate(100%);
  } */

  @media only screen and (min-width: 960px) {
    top: 0;
    right: 0;
    left: 0;
    bottom: unset;

    /* &:before {
      display: block;
    } */
  }
`

export const NavigationBar = styled.nav`
  background: ${color('secondaryBackground')};
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 100;
  ul {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
  }

  @media only screen and (min-width: 960px) {
    --navigation-height: 80px;
    padding-top: 0;
    top: 0;
    bottom: 0;
    left: 0;
    height: 100vh;
    right: unset;

    ul {
      padding-top: ${space(1)};
      flex-direction: column;
      width: var(--navigation-width);
    }
  }
`

export const NavigationItem = styled.li`
  flex: 1;
  font-family: ${font('extended')};
  font-size: 0.471rem;
  font-weight: ${fontWeight('bold')};
  justify-items: center;

  line-height: 1.3;
  list-style: none;
  margin: 0;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &:not(:last-child) {
    &:after {
      background: ${color('primaryBorder')};
      content: '';
      display: block;
      height: calc(var(--navigation-height) - ${space(6)});
      position: absolute;
      right: 0;
      top: ${space(3)};
      width: 1px;
    }
  }

  a {
    align-items: center;
    color: ${color('interactive')};
    display: flex;
    flex-direction: column;
    height: var(--navigation-height);
    justify-content: flex-start;
    padding: ${space(3)} ${space(3)};
    .icon {
      margin-bottom: ${space(1)};
    }
    &:hover {
      color: ${color('interactiveHover')};
    }

    @media (hover: none) {
      &:hover {
        color: currentColor;
      }
    }
    &.active {
      color: ${color('interactiveHover')};
    }
  }

  @media only screen and (min-width: 960px) {
    &:not(:last-child) {
      &:after {
        content: '';
        left: ${space(3)};
        top: unset;
        bottom: 0;
        height: 1px;
        width: calc(var(--navigation-width) - ${space(6)});
      }
    }

    a {
      justify-content: center;
      padding: ${space(4)} ${space(3)};
    }
  }
`
